import React from "react";
import "./tiresStyles.css";
import { Typography } from "@material-ui/core";

const Tires = ({ tier = [] }) => {
  const tierMap = tier.reduce((acc, item) => {
    acc[item.prefix] = item;
    return acc;
  }, {});

  const renderItem = (item, className = "", isComplete = true) =>
    item ? (
      <div
        className={`${isComplete ? "tiresItemCnt" : "key"} ${className}`}
        style={{
          color: item.color || "#000",
          backgroundColor: item["background-color"] || "#eee",
          border: `1.5px solid ${item.color || "#999"}`,
        }}
      >
        {item.title}
        {isComplete && <Typography variant="body1">{item?.body}</Typography>}
      </div>
    ) : null;

  return (
    <>
      <div className="tires-container">
        {["A", "B", "C", "D", "E"].map((prefix) => renderItem(tierMap[prefix]))}
      </div>

      <div className="keys-container">
        <h3 className="keys-title">Keys</h3>
        <div className="keys-box">
          <div className="tierInncerCnt">
            {["A", "B", "C"].map((prefix) =>
              renderItem(tierMap[prefix], "", false)
            )}
          </div>
          <div className="tierInncerCnt">
            {["D", "E"].map((prefix) => renderItem(tierMap[prefix], "", false))}
            <div className="lastTier">
              {["I", "P"].map((prefix) =>
                renderItem(tierMap[prefix], "", false)
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tires;
